import "core-js/modules/es6.array.find-index";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { dicOption } from '@/option/config';
import { getList as _getList, getObj, addObj, delObj, updateObj } from '@/api/bigscreen/category';
export default {
  data: function data() {
    return {
      dicOption: dicOption,
      dialogVisible: false,
      optionsList: [{
        val: 1,
        text: '开启'
      }, {
        val: 2,
        text: '关闭'
      }],
      addVal: '',
      addText: '',
      addFlag: false,
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      oneList: [{
        value: '1',
        label: '黄金糕'
      }, {
        value: '2',
        label: '双皮奶'
      }, {
        value: '3',
        label: '测试'
      }],
      oneId: ''
    };
  },
  inject: ["main"],
  mounted: function mounted() {// this.getList()
  },
  watch: {
    gatewayvalue: function gatewayvalue(newVal) {
      this.getList();
    },
    oneId: function oneId(newVal) {
      this.setText(newVal);
    }
  },
  methods: {
    getList: function getList() {
      var _this = this;

      _getList({
        current: 1,
        size: 100
      }).then(function (res) {
        console.log(_this, res, ' ---res');

        _this.main.handleTextSet('categoryKey');
      });
    },
    addline: function addline() {
      this.addFlag = true;
    },
    setText: function setText(newVal) {
      console.log(this.optionsList, '--this.optionsList');
      var findIndex = this.optionsList.findIndex(function (item) {
        return item.val == newVal;
      });
      console.log(findIndex, '-findIndex');
      this.main.handleTextSet(this.optionsList[findIndex].text);
    },
    submitHandle: function submitHandle() {
      var _this2 = this;

      if (this.addText && this.addVal) {
        this.$nextTick(function () {
          _this2.optionsList.push({
            val: _this2.addVal,
            text: _this2.addText
          });
        });
      }
    }
  }
};